<div style="margin-left: 4%; margin-right: 4%">
  @if (showErrorsDisclaimer) {
    <div id="errorDisclaimerID" style="margin-top: 2.625rem" class="errorDisclaimer">
      <img src="assets/error.svg" />
      <span> There are errors on the form. Please fix the errors in order to continue. </span>
    </div>
  }
  @if (displayRevisionNumber > 0) {
    <div>
      <div style="margin-top: 2.625rem; display: inline-block">
        <span class="itProjectHeader" style="font-size: 1.313rem"
          >Form #{{ formNumber }}, Rev {{ displayRevisionNumber }}</span
        >
      </div>
      <div style="display: inline-block; float: right; margin-top: 2.625rem; margin-right: 1.4rem">
        @if (formStatus === 'Draft' || draftSaved || formStatus === 'Draft (Revision)') {
          <button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Actions">
            <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
          </button>
        }
        <mat-menu #menu="matMenu">
          <button mat-menu-item>
            <span>Print Form</span>
          </button>
          @if (showDelete()) {
            <button mat-menu-item (click)="openDeleteConfirmationDialog()">
              <span>Delete Form</span>
            </button>
          }
        </mat-menu>
        <div class="exitButton" (click)="saveDraft()">
          <span class="exitText">SAVE DRAFT</span>
        </div>
      </div>
    </div>
  }
  <div style="display: inline-block; margin-top: 2.625rem">
    <span class="itProjectHeader">Accounting Request Form</span>
  </div>
  @if (draftSaved) {
    <div style="display: inline-block; margin-top: 2.625rem">
      <div
        style="
          display: inline-block;
          margin-left: 1rem;
          background: #d7d9da 0% 0% no-repeat padding-box;
          border-radius: 8px;
          opacity: 1;
          width: 3.438rem;
          text-align: center;
        "
      >
        <span style="color: #4c4c4c; font-size: 0.875rem">Draft</span>
      </div>
      <div style="display: inline-block; margin-left: 1rem">
        <span style="color: #4c4c4c; font-size: 0.75rem; font-style: italic"
          >Saved {{ draftSavedTime }} on {{ draftSavedDay }}</span
        >
      </div>
    </div>
  }
  @if (displayRevisionNumber === 0) {
    <div style="display: inline-block; float: right; margin-top: 2.625rem; margin-right: 1.4rem">
      @if (formStatus === 'Draft' || draftSaved) {
        <button [matMenuTriggerFor]="menu" class="action-button" matTooltip="Actions">
          <mat-icon style="color: rgb(0, 120, 158)">more_vert</mat-icon>
        </button>
      }
      <mat-menu #menu="matMenu">
        <button mat-menu-item>
          <span>Print Form</span>
        </button>
        @if (showDelete()) {
          <button mat-menu-item (click)="openDeleteConfirmationDialog()">
            <span>Delete Form</span>
          </button>
        }
      </mat-menu>
      <div class="exitButton" (click)="saveDraft()">
        <span class="exitText">SAVE DRAFT</span>
      </div>
    </div>
  }
  <form #projectSetupForm="ngForm" (keydown.enter)="$event.preventDefault()">
    <div style="margin-top: 1.5rem; display: flex">
      <div
        style="width: 34rem; height: 6.25rem; background-color: #f3fafd"
        [class.backgroundWhite]="isRevisionIndicator"
      >
        @if (!isRevisionIndicator) {
          <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
            @if (!(patiProject && patiProject.Project_ID)) {
              <mat-form-field class="itFields" style="width: 30rem">
                <input
                  type="text"
                  placeholder="PaTI ID #"
                  matAutocompletePosition="below"
                  matInput
                  [matAutocomplete]="auto3"
                  [formControl]="patiProjectControl"
                  [(ngModel)]="patiProject"
                  [disabled]="gettingPatiIds"
                  required
                  name="patiIdField"
                />
              </mat-form-field>
            }
            @if (patiProject && patiProject.Project_ID) {
              <mat-form-field class="itFields" style="width: 30rem">
                <input
                  type="text"
                  placeholder="PaTI ID #"
                  matAutocompletePosition="below"
                  matInput
                  [matAutocomplete]="auto3"
                  [formControl]="patiProjectControl"
                  [(ngModel)]="patiProject"
                  [disabled]="gettingPatiIds"
                  readonly="true"
                />
              </mat-form-field>
            }
            <mat-autocomplete
              #auto3="matAutocomplete"
              [displayWith]="displayFnPatiProject"
              (optionSelected)="projectSetupForm.resetForm()"
            >
              @for (option of filteredPatiProjectOptions | async; track option) {
                <mat-option style="color: #696969" [value]="option"
                  ><span>{{ option.Project_ID }} - {{ option.Project_Name }}</span></mat-option
                >
              }
            </mat-autocomplete>
          </div>
        }
        @if (isRevisionIndicator) {
          <div style="display: inline-block; margin-top: 1.125rem">
            <mat-form-field class="itFields" style="width: 30rem">
              <input
                matInput
                readonly="true"
                placeholder="PaTI ID #"
                [(ngModel)]="displayPatiProject"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          </div>
        }
      </div>
      @if (patiProject && patiProject.Project_ID && !isRevisionIndicator) {
        <div style="padding-top: 1.813rem; z-index: 0">
          <img
            (click)="deletePatiProject()"
            style="margin-left: -3.125rem; cursor: pointer"
            src="assets/close-window.svg"
          />
        </div>
      }
    </div>
    @if (patiProject && patiProject.Project_Name) {
      <div>
        <div style="display: flex">
          <div style="margin-top: 1.5rem">
            <div style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd">
              <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <input
                    maxlength="35"
                    [(ngModel)]="projectName"
                    placeholder="Short Description (Max 35 Characters)"
                    matInput
                    required
                    name="shortDescField"
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div style="display: inline-block; margin-top: 1.5rem">
            <div style="width: 23.438rem; height: 6.25rem; background-color: #f3fafd">
              <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
                <mat-form-field class="itFields" style="width: 19.4rem">
                  <mat-select
                    [(ngModel)]="itProjectClassification"
                    placeholder="IT Project Classification"
                    required
                    name="classificationField"
                    [compareWith]="compareItProjectClassification"
                  >
                    @for (option of itProjectClassificationOptions; track option) {
                      <mat-option style="color: #696969" [value]="option"
                        ><span>{{ option.ets_proj_classification }}</span></mat-option
                      >
                    }
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-top: 1.5rem; margin-right: 1.5rem">
          <div style="width: 48.375rem; height: 6.25rem; background-color: #f3fafd">
            <mat-form-field
              style="
                background: white;
                padding-left: 0.4rem;
                padding-right: 0.4rem;
                margin-top: 1.125rem;
                margin-left: 1.5rem;
                width: 21.438rem;
                height: 4rem;
              "
            >
              <mat-label>Estimated Start Date</mat-label>
              <input
                matInput
                #datepickerInput1
                [matDatepicker]="startDatePicker"
                [(ngModel)]="estimatedStartDate"
                style="color: #696969"
                [max]="estimatedInServiceDate"
                (dateChange)="onStartDateChange()"
                required
                name="estimatedStartDateField"
              />
              <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #startDatePicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field
              style="
                background: white;
                padding-left: 0.4rem;
                padding-right: 0.4rem;
                margin-left: 1.5rem;
                width: 21.438rem;
                height: 4rem;
              "
            >
              <mat-label>Estimated In Service Date</mat-label>
              <input
                matInput
                #datepickerInput2
                [matDatepicker]="inServiceDatePicker"
                [(ngModel)]="estimatedInServiceDate"
                [min]="minimumInServiceDate()"
                style="color: #696969"
                (dateChange)="onInServiceDateChange()"
                required
                name="estimatedInServiceDateField"
              />
              <mat-datepicker-toggle matSuffix [for]="inServiceDatePicker"></mat-datepicker-toggle>
              <mat-datepicker #inServiceDatePicker></mat-datepicker>
            </mat-form-field>
          </div>
        </div>
        <div style="margin-top: 1.5rem">
          <span
            class="projectScopeHeader"
            [style.color]="
              projectSetupForm.submitted &&
              projectSetupForm.controls['projectScopeDescriptionField']?.errors?.required
                ? '#9e1b32'
                : ''
            "
            >Overview and Scope</span
          >
        </div>
        <div style="margin-top: 0.688rem">
          <textarea
            [(ngModel)]="projectScopeDescription"
            [style.border]="
              projectSetupForm.submitted &&
              projectSetupForm.controls['projectScopeDescriptionField']?.errors?.required
                ? '1px solid #9e1b32'
                : ''
            "
            class="scopeDescriptionTextBox"
            maxlength="255"
            required
            name="projectScopeDescriptionField"
          ></textarea>
        </div>
        <div>
          <span style="color: #696969; font-style: italic; margin-right: 36.938rem; float: right"
            >{{ scopeLength() }} / 255 characters</span
          >
        </div>
        <div style="margin-top: 1.5rem">
          <span class="projectScopeHeader">Contacts</span>
        </div>
        <div style="margin-top: 0.688rem">
          <div style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd">
            @if (!(primaryContact && primaryContact.mail)) {
              <mat-form-field
                class="itFields"
                style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem"
              >
                <input
                  name="primaryContactField"
                  type="text"
                  placeholder="Primary Contact (Search for a name and then make a selection)"
                  matAutocompletePosition="below"
                  matInput
                  [matAutocomplete]="auto1"
                  [formControl]="primaryContactControl"
                  [(ngModel)]="primaryContact"
                  required
                  (keydown.enter)="searchUsersPrimaryContact($event.target.value)"
                />
              </mat-form-field>
            }
            @if (primaryContact && primaryContact.mail) {
              <mat-form-field
                class="itFields"
                style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem"
              >
                <input
                  name="primaryContactField"
                  type="text"
                  placeholder="Primary Contact (Search for a name and then make a selection)"
                  matAutocompletePosition="below"
                  matInput
                  [matAutocomplete]="auto1"
                  [formControl]="primaryContactControl"
                  [(ngModel)]="primaryContact"
                  readonly="true"
                />
              </mat-form-field>
            }
            <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFnPrimaryContact">
              @for (option of primaryContactOptions; track option) {
                <mat-option style="color: #696969" [value]="option">
                  @if (option.givenName && option.surname && option.jobTitle) {
                    <span
                      >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                      {{ option.jobTitle }}</span
                    >
                  }
                  @if (option.givenName && option.surname && !option.jobTitle) {
                    <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
                  }
                  @if (!(option.givenName && option.surname) && option.jobTitle) {
                    <span>{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span>
                  }
                  @if (!(option.givenName && option.surname) && !option.jobTitle) {
                    <span>{{ option.displayName }} ({{ option.mail }})</span>
                  }
                </mat-option>
              }
            </mat-autocomplete>
            @if (primaryContact && primaryContact.mail) {
              <div
                style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute"
              >
                <img
                  (click)="deletePrimaryContact()"
                  style="margin-left: -1.5rem; cursor: pointer"
                  src="assets/close-window.svg"
                />
              </div>
            }
            <div style="display: inline-block; margin-left: 0.938rem">
              <button
                class="confirmButton"
                type="button"
                style="width: 5rem"
                (click)="searchUsersPrimaryContact(primaryContact)"
              >
                <span class="confirmText">SEARCH</span>
              </button>
            </div>
          </div>
        </div>
        <div style="margin-top: 0.688rem">
          <div style="width: 66.375rem; height: 6.25rem; background-color: #f3fafd">
            @if (!(itSponsor && itSponsor.mail)) {
              <mat-form-field
                class="itFields"
                style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem"
              >
                <input
                  name="itSponsorField"
                  type="text"
                  placeholder="Sponsor (Search for a name and then make a selection)"
                  matAutocompletePosition="below"
                  matInput
                  [matAutocomplete]="auto2"
                  [formControl]="itSponsorControl"
                  [(ngModel)]="itSponsor"
                  (keydown.enter)="searchUsersItSponsor($event.target.value)"
                  required
                />
              </mat-form-field>
            }
            @if (itSponsor && itSponsor.mail) {
              <mat-form-field
                class="itFields"
                style="margin-top: 1.125rem; margin-left: 1.5rem; width: 55.638rem; height: 4rem"
              >
                <input
                  name="itSponsor"
                  type="text"
                  placeholder="Sponsor (Search for a name and then make a selection)"
                  matAutocompletePosition="below"
                  matInput
                  [matAutocomplete]="auto2"
                  [formControl]="itSponsorControl"
                  [(ngModel)]="itSponsor"
                  readonly="true"
                />
              </mat-form-field>
            }
            <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFnITSponsor">
              @for (option of itSponsorOptions; track option) {
                <mat-option style="color: #696969" [value]="option">
                  @if (option.givenName && option.surname && option.jobTitle) {
                    <span
                      >{{ option.givenName }} {{ option.surname }} ({{ option.mail }}),
                      {{ option.jobTitle }}</span
                    >
                  }
                  @if (option.givenName && option.surname && !option.jobTitle) {
                    <span>{{ option.givenName }} {{ option.surname }} ({{ option.mail }})</span>
                  }
                  @if (!(option.givenName && option.surname) && option.jobTitle) {
                    <span>{{ option.displayName }} ({{ option.mail }}), {{ option.jobTitle }}</span>
                  }
                  @if (!(option.givenName && option.surname) && !option.jobTitle) {
                    <span>{{ option.displayName }} ({{ option.mail }})</span>
                  }
                </mat-option>
              }
            </mat-autocomplete>
            @if (itSponsor && itSponsor.mail) {
              <div
                style="display: inline-block; padding-top: 1.813rem; z-index: 0; position: absolute"
              >
                <img
                  (click)="deleteITSponsor()"
                  style="margin-left: -1.5rem; cursor: pointer"
                  src="assets/close-window.svg"
                />
              </div>
            }
            <div style="display: inline-block; margin-left: 0.938rem">
              <button
                class="confirmButton"
                type="button"
                style="width: 5rem"
                (click)="searchUsersItSponsor(itSponsor)"
              >
                <span class="confirmText">SEARCH</span>
              </button>
            </div>
          </div>
        </div>
        @if (!isRevisionIndicator) {
          <div
            style="
              width: fit-content;
              background-color: #f3fafd;
              margin-top: 1.5rem;
              padding: 1rem 1.5rem;
            "
          >
            <div
              style="
                display: flex;
                gap: 1rem;
                color: dimgray;
                padding: 0.5rem;
                background-color: white;
              "
            >
              <span
                [style.color]="
                  projectSetupForm.submitted &&
                  projectSetupForm.controls['omOnlyField']?.errors?.required
                    ? '#9e1b32'
                    : ''
                "
                >Is this request O&M only?</span
              >
              <mat-radio-group
                [(ngModel)]="omOnly"
                required
                name="omOnlyField"
                (change)="omOnlyChanged()"
              >
                <mat-radio-button color="primary" [value]="'YES'">
                  <span class="choiceText">YES</span>
                </mat-radio-button>
                <mat-radio-button color="primary" [value]="'NO'" style="margin-left: 1.125rem">
                  <span class="choiceText">NO</span>
                </mat-radio-button>
              </mat-radio-group>
            </div>
          </div>
        }
        <div style="display: inline-block; margin-top: 1.125rem; margin-left: 1.5rem">
          @if (!isRevisionIndicator && omOnly) {
            <mat-form-field class="itFields" style="width: 20.4rem">
              <mat-select
                [(ngModel)]="relatedWork"
                placeholder="Does this work relate to:"
                (selectionChange)="relatedWorkChanged()"
                required
                name="relatedWorkField"
              >
                @for (option of hardwareOrSoftwareOptions; track option) {
                  <mat-option style="color: #696969" [value]="option"
                    ><span>{{ option }}</span></mat-option
                  >
                }
              </mat-select>
            </mat-form-field>
          }
          @if (isRevisionIndicator) {
            <mat-form-field class="itFields" style="width: 20.4rem">
              <input
                readonly="true"
                type="text"
                placeholder="What type of work is this?"
                matInput
                [(ngModel)]="hardwareOrSoftware"
                [ngModelOptions]="{ standalone: true }"
              />
            </mat-form-field>
          }
        </div>
        @if (
          hardwareOrSoftware === 'Hardware Only' || hardwareOrSoftware === 'Hardware and Software'
        ) {
          <div>
            <div style="margin-top: 1.5rem">
              <span class="projectScopeHeader">Hardware Details</span>
            </div>
            <div style="margin-top: 0.688rem">
              <div style="width: 73.25rem; background-color: #f3fafd">
                <div style="position: relative">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      margin-bottom: 1.5rem;
                      width: 34.438rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['purchasingWarrantiesField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Are you purchasing any service warranties? (If yes, the cost of service
                      warranties should be included in O&M estimate; none of this cost can be
                      capitalized)</span
                    >
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 7.375rem;
                      vertical-align: top;
                      position: absolute;
                      top: 0.625rem;
                    "
                  >
                    <mat-radio-group
                      [(ngModel)]="purchasingWarranties"
                      required
                      name="purchasingWarrantiesField"
                    >
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
        @if (
          hardwareOrSoftware === 'Software Only' || hardwareOrSoftware === 'Hardware and Software'
        ) {
          <div>
            <div style="margin-top: 1.5rem">
              <span class="projectScopeHeader">Software Details</span>
            </div>
            <div style="margin-top: 0.688rem">
              <div style="width: 73.25rem; background-color: #f3fafd">
                <div style="padding-top: 1rem; padding-left: 1rem">
                  <span
                    [style.color]="
                      projectSetupForm.submitted && !(projectConsistsOf && projectConsistsOf.length)
                        ? '#9e1b32'
                        : 'gray'
                    "
                    >Work consists of the following: (Select all that apply)
                  </span>
                  @for (option of projectConsistsOfOptions; track option; let i = $index) {
                    <div style="text-align: left; margin-bottom: 0.938rem">
                      <mat-checkbox
                        color="primary"
                        [checked]="projectConsistsOfCheckboxes[i]"
                        (change)="consistsOfChange(i, option)"
                        required
                        name="projectConsistsOfField"
                      >
                        <span style="color: #696969; white-space: normal">{{ option }}</span>
                      </mat-checkbox>
                    </div>
                  }
                </div>
                <div>
                  <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                    <mat-form-field class="itFields" style="width: 20.4rem" [floatLabel]="'always'">
                      <input
                        type="number"
                        step="1"
                        min="0"
                        [(ngModel)]="expectedLife"
                        placeholder="What is the expected life of the software (years)?"
                        oninput="
                          this.value =
                            !!this.value && Math.abs(this.value) >= 0 ? Math.abs(this.value) : null
                        "
                        matInput
                        required
                        name="expectedLifeField"
                      />
                    </mat-form-field>
                  </div>
                </div>
                <div style="position: relative">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 34.438rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['agileEffortField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Is this an Agile effort?</span
                    >
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 7.375rem;
                      vertical-align: top;
                      position: absolute;
                      top: 0.625rem;
                    "
                  >
                    <mat-radio-group [(ngModel)]="agileEffort" required name="agileEffortField">
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div style="position: relative">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 34.438rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['softwareBeingUsedField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Does the software currently exist or is it being used for any other
                      jurisdictions, department, business unit, or function?</span
                    >
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 7.375rem;
                      vertical-align: top;
                      position: absolute;
                      top: 0.625rem;
                    "
                  >
                    <mat-radio-group
                      [(ngModel)]="softwareBeingUsed"
                      required
                      name="softwareBeingUsedField"
                    >
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div>
                  <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                    <mat-form-field class="itFields" style="width: 19.4rem">
                      <input
                        [(ngModel)]="vendorName"
                        placeholder="Vendor Name (Optional)"
                        matInput
                        name="vendorNameField"
                      />
                    </mat-form-field>
                  </div>
                  <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                    <mat-form-field class="itFields" style="width: 19.4rem">
                      <input
                        [(ngModel)]="softwareName"
                        placeholder="Software Name (Optional)"
                        matInput
                        name="softwareNameField"
                      />
                    </mat-form-field>
                  </div>
                  @if (softwareBeingUsed !== 'NO') {
                    <div style="display: inline-block; margin-top: 1.5rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          matInput
                          readonly
                          [(ngModel)]="inServiceYear"
                          placeholder="In what year did it go in service?"
                          required
                          name="inServiceYearField"
                        />
                        <input
                          matInput
                          [matDatepicker]="dp"
                          [max]="currentDate"
                          [value]="getInServiceDate()"
                          class="service-year-dummy-input"
                        />
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker
                          #dp
                          startView="multi-year"
                          (yearSelected)="onInServiceYearSelection($event, dp)"
                        >
                        </mat-datepicker>
                      </mat-form-field>
                    </div>
                  }
                </div>
                <div style="margin-top: 1.5rem; margin-left: 1.5rem">
                  <span
                    class="bodyText"
                    [style.color]="
                      projectSetupForm.submitted &&
                      projectSetupForm.controls['softwareProjectOverviewField']?.errors?.required
                        ? '#9e1b32'
                        : ''
                    "
                    >Describe the software development work needed for this effort:</span
                  >
                </div>
                <div style="margin-top: 0.688rem; margin-left: 1.5rem">
                  <textarea
                    [(ngModel)]="softwareProjectOverview"
                    class="softwareProjectOverviewTextBox"
                    [style.border]="
                      projectSetupForm.submitted &&
                      projectSetupForm.controls['softwareProjectOverviewField']?.errors?.required
                        ? '1px solid #9e1b32'
                        : ''
                    "
                    style="height: 4rem; width: 45.375rem"
                    maxlength="255"
                    required
                    name="softwareProjectOverviewField"
                  ></textarea>
                </div>
                <div>
                  <span
                    style="
                      color: #696969;
                      font-style: italic;
                      float: right;
                      position: absolute;
                      right: 42.813rem;
                    "
                    >{{ softwareProjectLength() }} / 255 characters</span
                  >
                </div>
                <div style="width: 50.938rem">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 37.688rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['dataConversionActivitiesField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Will you have data conversion activities? (If yes, the cost of running
                      processes or manually cleaning up data should be included in O&M estimate;
                      only development of data conversion software can be capitalized)</span
                    >
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      vertical-align: top;
                      float: right;
                    "
                  >
                    <mat-radio-group
                      [(ngModel)]="dataConversionActivities"
                      required
                      name="dataConversionActivitiesField"
                    >
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div style="width: 50.938rem">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 37.688rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['trainingCostsField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Will you have training costs? (If yes, the cost of train-the-trainer and user
                      training should be included in O&M estimate; only developer training on how to
                      develop the software can be capitalized)</span
                    >
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      vertical-align: top;
                      float: right;
                    "
                  >
                    <mat-radio-group [(ngModel)]="trainingCosts" required name="trainingCostsField">
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div style="width: 50.938rem">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 37.688rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['associatedRetirementField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Is there an associated retirement of existing software?</span
                    >
                  </div>
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      vertical-align: top;
                      float: right;
                    "
                  >
                    <mat-radio-group
                      [(ngModel)]="associatedRetirement"
                      required
                      name="associatedRetirementField"
                    >
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                @if (associatedRetirement === 'YES') {
                  <div style="display: inline-block">
                    <div style="display: inline-block; margin-top: 0.688rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          [(ngModel)]="softwareToBeRetired"
                          placeholder="Software To Be Retired"
                          matInput
                          required
                          name="softwareToBeRetiredField"
                        />
                      </mat-form-field>
                    </div>
                    <div style="display: inline-block; margin-top: 0.688rem; margin-left: 1.5rem">
                      <mat-form-field class="itFields" style="width: 19.4rem">
                        <input
                          [(ngModel)]="retiredInServiceDate"
                          placeholder="When was it in service?"
                          matInput
                          name="retiredInServiceDateField"
                        />
                      </mat-form-field>
                    </div>
                  </div>
                }
                <div style="width: 50.938rem">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 37.688rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['maintenanceContractsField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Will you have any maintenance contracts/agreements?</span
                    >
                  </div>
                  <div
                    [class.moveDown]="associatedRetirement === 'YES'"
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      vertical-align: top;
                      float: right;
                      position: relative;
                      top: -3.313rem;
                    "
                  >
                    <mat-radio-group
                      [(ngModel)]="maintenanceContracts"
                      required
                      name="maintenanceContractsField"
                    >
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div style="width: 50.938rem">
                  <div
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      width: 37.688rem;
                    "
                  >
                    <span
                      class="bodyText"
                      [style.color]="
                        projectSetupForm.submitted &&
                        projectSetupForm.controls['replacingInterfacesField']?.errors?.required
                          ? '#9e1b32'
                          : ''
                      "
                      >Are you replacing any existing interfaces?</span
                    >
                  </div>
                  <div
                    [class.moveLeft]="associatedRetirement === 'YES'"
                    style="
                      display: inline-block;
                      margin-top: 1.5rem;
                      vertical-align: top;
                      float: right;
                      position: relative;
                      top: -3.313rem;
                      left: 7.48rem;
                    "
                  >
                    <mat-radio-group
                      [(ngModel)]="replacingInterfaces"
                      required
                      name="replacingInterfacesField"
                    >
                      <mat-radio-button color="primary" [value]="'YES'">
                        <span class="choiceText">YES</span>
                      </mat-radio-button>
                      <mat-radio-button
                        color="primary"
                        [value]="'NO'"
                        style="margin-left: 1.125rem"
                      >
                        <span class="choiceText">NO</span>
                      </mat-radio-button>
                    </mat-radio-group>
                  </div>
                </div>
                <div>
                  <mat-form-field
                    class="itFields"
                    style="
                      margin-top: 1.5rem;
                      margin-left: 1.5rem;
                      margin-bottom: 1.5rem;
                      width: 30.938rem;
                    "
                  >
                    <mat-select
                      [(ngModel)]="howSoftwareReleased"
                      placeholder="How will the software be released?"
                      required
                      name="howSoftwareReleasedsField"
                    >
                      @for (option of howSoftwareReleasedOptions; track option) {
                        <mat-option style="color: #696969" [value]="option"
                          ><span>{{ option }}</span></mat-option
                        >
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
                @if (isVendorHosted()) {
                  <div style="width: 50.938rem">
                    <div style="display: inline-block; margin-left: 1.5rem; width: 37.688rem">
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.submitted &&
                          projectSetupForm.controls['perpetualLicensesField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Will Duke own perpetual licenses?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        vertical-align: top;
                        float: right;
                        position: relative;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="perpetualLicenses"
                        required
                        name="perpetualLicensesField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                }
                @if (isVendorHosted()) {
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 36.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.submitted &&
                          projectSetupForm.controls['contractualRightField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Does Duke have the contractual right to take possession of the software at
                        any time during the arrangement period?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="contractualRight"
                        required
                        name="contractualRightField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                }
                @if (isVendorHosted()) {
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.submitted &&
                          projectSetupForm.controls['significantPenaltytField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Is there a significant penalty to take possession of the software and bring
                        it in house? (Significant penalty is interpreted as either a significant
                        cost or significant reduction in value or functionality when taking
                        possession of the software. Significant cost is defined as greater than 15%
                        of the total capital cost of the project)</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -6.313rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="significantPenalty"
                        required
                        name="significantPenaltytField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                }
                @if (isVendorHosted()) {
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 34.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.submitted &&
                          projectSetupForm.controls['isFeasibleField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Is it feasible for Duke to run the software on our own hardware or to
                        contract with another third party host?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 0.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                      "
                    >
                      <mat-radio-group [(ngModel)]="isFeasible" required name="isFeasibleField">
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                }
                @if (isVendorHosted()) {
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.submitted &&
                          projectSetupForm.controls['serviceFeesField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >Are there service or usage fees?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                      "
                    >
                      <mat-radio-group [(ngModel)]="serviceFees" required name="serviceFeesField">
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                }
                @if (isVendorHosted()) {
                  <div style="width: 50.938rem">
                    <div
                      style="
                        display: inline-block;
                        margin-top: 1.5rem;
                        margin-left: 1.5rem;
                        margin-bottom: 1.5rem;
                        width: 37.688rem;
                      "
                    >
                      <span
                        class="bodyText"
                        [style.color]="
                          projectSetupForm.submitted &&
                          projectSetupForm.controls['useWithoutPayingField']?.errors?.required
                            ? '#9e1b32'
                            : ''
                        "
                        >If we stop paying the service or usage fees, can we still use the
                        software?</span
                      >
                    </div>
                    <div
                      style="
                        display: inline-block;
                        vertical-align: top;
                        float: right;
                        position: relative;
                        top: -3.313rem;
                      "
                    >
                      <mat-radio-group
                        [(ngModel)]="useWithoutPaying"
                        required
                        name="useWithoutPayingField"
                      >
                        <mat-radio-button color="primary" [value]="'YES'">
                          <span class="choiceText">YES</span>
                        </mat-radio-button>
                        <mat-radio-button
                          color="primary"
                          [value]="'NO'"
                          style="margin-left: 1.125rem"
                        >
                          <span class="choiceText">NO</span>
                        </mat-radio-button>
                      </mat-radio-group>
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
    <div style="margin-bottom: 4.375rem; margin-top: 3.75rem">
      <div class="startOverButton" (click)="startOver()">
        <span style="font-size: 0.875rem; color: #00789e">START OVER</span>
      </div>
      <div style="display: inline-block">
        <div class="exitButton" (click)="exitPage()">
          <span class="exitText">EXIT</span>
        </div>
      </div>
      <div style="display: inline-block; float: right">
        <div style="display: inline-block">
          <button
            (click)="confirmAndContinue(projectSetupForm)"
            type="submit"
            class="confirmButton"
          >
            <span class="confirmText">NEXT</span>
          </button>
        </div>
      </div>
      <div style="display: inline-block; float: right; margin-right: 1.4rem">
        <div class="exitButton" (click)="saveDraft()">
          <span class="exitText">SAVE DRAFT</span>
        </div>
      </div>
    </div>
  </form>
</div>
